import * as React from "react";
const SvgMoveDown2 = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 24h24V0H0z" data-name="Trazado 510" style={{
    fill: "none"
  }} /><path d="m4 12 1.41-1.41L11 16.17V4h2v12.17l5.58-5.59L20 12l-8 8z" data-name="Trazado 511" /></svg>;
export { SvgMoveDown2 as ReactComponent };